import { useMemo, useState } from 'react';
import { reviews } from '@/mocks/russianMom';

const filters = [
  { key: 'all', label: '全部短评' },
  { key: '5', label: '五星好评' },
  { key: '4', label: '四星中评' },
];

export default function ReviewSection() {
  const [filter, setFilter] = useState('all');

  const list = useMemo(() => {
    if (filter === 'all') return reviews;
    return reviews.filter((r) => String(r.rating) === filter);
  }, [filter]);

  return (
    <section id="reviews" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
            <i className="ri-chat-smile-2-line" aria-hidden="true"></i>
            观众短评
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            1,842 条短评里的真实感受
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600">
            以下为观众对剧情、节奏与表演的普遍反馈整理，供你在观看前作个参考。
          </p>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-6 lg:grid-cols-[300px_1fr]">
          <div className="rounded-lg border border-background-200 bg-background-50 p-5">
            <div className="flex items-end gap-2">
              <span className="font-heading text-4xl font-black text-primary-600">8.7</span>
              <span className="pb-1 text-xs text-foreground-500">/ 10 综合评分</span>
            </div>
            <div className="mt-3 flex items-center gap-1">
              {[0, 1, 2, 3, 4].map((i) => (
                <i key={i} className="ri-star-fill text-base text-accent-500" aria-hidden="true"></i>
              ))}
            </div>
            <div className="mt-5 space-y-2.5">
              {[
                { star: '五星', pct: 72 },
                { star: '四星', pct: 21 },
                { star: '三星及以下', pct: 7 },
              ].map((row) => (
                <div key={row.star} className="flex items-center gap-3">
                  <span className="w-20 shrink-0 text-xs text-foreground-600">{row.star}</span>
                  <span className="h-1.5 flex-1 overflow-hidden rounded-full bg-background-200">
                    <span className="block h-full rounded-full bg-primary-500" style={{ width: `${row.pct}%` }}></span>
                  </span>
                  <span className="w-9 shrink-0 text-right text-xs text-foreground-500">{row.pct}%</span>
                </div>
              ))}
            </div>
            <p className="mt-5 border-t border-background-200 pt-4 text-xs leading-6 text-foreground-500">
              数据为观众打分汇总整理，仅用于参考，不代表任何官方评价。
            </p>
          </div>

          <div>
            <div className="flex flex-wrap gap-2">
              {filters.map((f) => (
                <button
                  key={f.key}
                  type="button"
                  onClick={() => setFilter(f.key)}
                  className={`whitespace-nowrap rounded-full border px-3.5 py-1.5 text-xs transition-colors ${
                    filter === f.key
                      ? 'border-primary-500 bg-primary-500 font-medium text-background-50'
                      : 'border-background-300 bg-background-50 text-foreground-600 hover:border-primary-300'
                  }`}
                >
                  {f.label}
                </button>
              ))}
            </div>

            <div className="mt-4 grid grid-cols-1 gap-4 sm:grid-cols-2">
              {list.map((r) => (
                <article key={r.id} className="rounded-lg border border-background-200 bg-background-50 p-4">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-2">
                      <span className="flex h-8 w-8 items-center justify-center rounded-full bg-secondary-100 font-heading text-sm font-bold text-secondary-800">
                        {r.user.slice(0, 1)}
                      </span>
                      <span className="text-sm font-medium text-foreground-900">{r.user}</span>
                    </div>
                    <span className="flex items-center gap-0.5">
                      {Array.from({ length: r.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-xs text-accent-500" aria-hidden="true"></i>
                      ))}
                    </span>
                  </div>
                  <p className="mt-3 text-xs leading-6 text-foreground-700">{r.text}</p>
                  <p className="mt-3 text-[11px] text-foreground-400">{r.date}</p>
                </article>
              ))}
              {list.length === 0 && (
                <p className="rounded-lg border border-dashed border-background-300 p-6 text-center text-sm text-foreground-500 sm:col-span-2">
                  该分类暂时没有整理到的短评。
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}